import { useContext, useEffect } from "react";
import AuthContext from "../../Context/auth/AuthContext";
import DeleteAccount from "./ProfileActions/DeleteAccount";

import { Box, Button, Typography, Grid } from "@mui/material";
import LevelProfile from "./LevelProfile";
import PersonalInformation from "./PersonalInformation";

export const Profile = () => {
  const { cerrarSesion, usuario, updateUser } = useContext(AuthContext);
  useEffect(() => {
    const updatedClientData = localStorage.getItem("updatedClient");
    if (updatedClientData) {
      try {
        const client = JSON.parse(updatedClientData);
        updateUser(client); // Actualiza el estado del usuario en el contexto
      } catch (error) {
        console.error(
          "Error al parsear la información del cliente de localStorage:",
          error
        );
      } finally {
        localStorage.removeItem("updatedClient"); // Limpia la información temporal
      }
    }
  }, [updateUser]);

  if (!usuario) {
    return null; // o un <CircularProgress /> si se prefiere
  }

  return (
    <Box sx={{ maxWidth: "1200px", margin: "0 auto", pt: 4, pb: 8, px: { xs: 2, md: 4 } }}>
      
      {/* Header del Dashboard */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 4, gap: 2 }}>
        <Box>
            <Typography variant="h4" fontWeight="800" color="#801F56" gutterBottom>
              Mi Panel
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Administra tu información personal y configuración
            </Typography>
        </Box>
        <Button
            variant="outlined"
            onClick={() => cerrarSesion()}
            sx={{
              color: "#801F56",
              borderColor: "#801F56",
              borderRadius: "12px",
              fontWeight: "600",
              px: 3,
              "&:hover": {
                backgroundColor: "rgba(128, 31, 85, 0.04)",
                borderColor: "#601540",
              },
            }}
          >
            Cerrar Sesión
        </Button>
      </Box>

      {/* Contenido */}
      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          <PersonalInformation usuario={usuario} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <LevelProfile puntos={usuario ? usuario.puntos : 0} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <DeleteAccount />
        </Grid>
      </Grid>

    </Box>
  );
};
